import { Component, OnInit, OnDestroy, Input, OnChanges } from '@angular/core';
import { SearchService } from '../search.service';
import { SearchCriteria, Metadata, ColumnMetaData, Condition, Clause, TableColumnAttribute } from '../models/search-filter-model';
import { SearchParams } from '../models/search-params.model';
import { ResourceService,ConfirmDialogService,AlertService } from 'sce-core';
import { UserService } from '../../../core/security/user.service';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { NavigationService } from '../../../core/navigation.service';
import { SearchableEntityDataService } from '../../services/searchable-entity/searchable-entity-data.service';
import { DatePickerConfigService } from '../../components/datepicker/datepicker-config.service';

@Component({
    selector: 'lfwms-search-filter',
    templateUrl: './search-filter.component.html',
    styleUrls: ['./search-filter.component.css']
})
export class SearchFilterComponent implements OnInit, OnDestroy, OnChanges {

    public searchParams: SearchParams;

    @Input() searchService: SearchService;
    @Input() dataService: SearchableEntityDataService;
    @Input() lookup: boolean;
    public isLookup: any;
    public filterComponent: SearchFilterComponent;
    // public dropDownValuesMap: any;
    public keyArray: any;
    public defaultOperator: string;
    public metaData: Metadata;
    public nonMandatoryMetaDataMap = [];
    public metaDataMap = {};
    public criterias: any;
    public dropDownValues: any = [];
    public checkBoxFlag = false;
    public textBox: boolean[] = [false];
    public dropDown: boolean[] = [false];
    public date: boolean[] = [false];
    public checkBox: boolean[] = [false];
    public dateTime: boolean[] = [false];
    public editableDropDown: boolean[] = [false];
    public operandsMap = [];
    private alertService: AlertService;
    public isDataLoaded = false;
    private storerKey = [];
    //[LFWM-3597] to check storer is mandatory or not in search criteria so, we can filter out dropdown values
    private isStorerMandatory = false;
    public filteredDropdownVal = [];
    public type: string;
    public parametersForPalletImage: any = {};
    protected confirmDialogService: ConfirmDialogService;
    public showLookupType = false;
    public tableColumnAttribute: TableColumnAttribute;

    constructor(public resourceService: ResourceService,
        public userService: UserService, protected sharedServiceRegistry: SharedServiceRegistry,
        protected navService: NavigationService, protected dateConfigService: DatePickerConfigService) {
        this.confirmDialogService = sharedServiceRegistry.confirmDialogService;
    }

    // method used to translate the labels
    public getLabel(key: any) {
        return this.resourceService.get(key);
    }

    public ngOnInit() {
        this.searchService.setNonMandatoryConditionsCount(0);
        this.alertService = this.searchService.searchParams.alertService;
        // Added value1 for between operator
        this.keyArray = ['id', 'logicalOperation', 'column', 'operation', 'value', 'value1'];
        const metaDataFromService = this.searchService.getMetadata();
        if (!metaDataFromService) {
            this.metaData = new Metadata();
            this.initializeMetadata();
        } else {
            this.metaData = metaDataFromService;
            this.populateMetaDataMap();
            this.initializeSearchCriteria();
            // if a search was already performed in the service, reload the results
            // if (this.searchService.searchStatus.hasResults) {
            //     // Clear the existing rows
            //     this.searchService.pagedData.pageRows.splice(0);
            //     this.searchService.performSearch();
            // }
            this.isDataLoaded = true;
        }
        this.initializeTableColumnAttribute();
        this.filterComponent = this;
        this.searchService.isSearchFilterInitialized = true;
    }

    public ngOnChanges() {

        const metaDataFromService = this.searchService.getMetadata();
        if (!metaDataFromService) {
            this.metaData = new Metadata();
            this.initializeMetadata();
        } else {
            this.metaData = metaDataFromService;
            this.populateMetaDataMap();
            this.initializeSearchCriteria();
            // if a search was already performed in the service, reload the results
            if (this.searchService.searchStatus.hasResults) {
                // JIRA LFWM-1375 Fixes Revisiting Search page duplicates search results
                // Clear the existing rows
                this.searchService.pagedData.pageRows.splice(0);
                this.searchService.performSearch();
            }
            this.isDataLoaded = true;
        }
        this.initializeTableColumnAttribute();
        this.filterComponent = this;
    }

    // method used to fetch the metadata from service
    public initializeMetadata() {
        this.searchService.fetchMetadata()
            .subscribe((metadata: any) => {
                this.metaData = metadata;
                // sorting the metadata based on indexes
                this.metaData.columnList.sort(function (a: any, b: any) {
                    return a.index - b.index; // compare indexes
                });
                this.searchService.setMetadata(metadata);
                // populating the metadatamap
                this.populateMetaDataMap();
                this.initializeSearchCriteria();
                this.isDataLoaded = true;
            });
    }

    private initializeSearchCriteria() {
        let searchCriteria = this.searchService.getSearchCriteria();
        if (searchCriteria === undefined || searchCriteria === null) {
            searchCriteria = this.createDefaultSearchCriteria();
            this.searchService.setSearchCriteria(searchCriteria);
        }
        // populating default value fields based on column type
        searchCriteria.conditions.forEach((condition) => {
            // checking the count of non mandatory conditions in the formed search criteria
            if (condition.isMandatory === false) {
                this.searchService.setNonMandatoryConditionsCount(this.searchService.getNonMandatoryConditionsCount() + 1);
            }
            condition.clauses.forEach((clause: any, index: any) => {
                if (this.metaDataMap[clause.column]) {
                    this.dynamicValuesFunction(this.metaDataMap[clause.column].type, index);
                }

            });
        });
    }

    // method used to populate metaData map
    public populateMetaDataMap() {
        this.criterias = [];
        this.metaData.columnList.forEach((column: any) => {
            // populating metaDataMap so as to get the metaData values corresponding to the conditions
            const columnMetaData = this.getColumnMetaData(column);
            this.metaDataMap[column.propertyName] = columnMetaData;
            // populating operands map based on the type of field
            /* if (columnMetaData.type === 'TEXTFIELD') {
                this.operandsMap[columnMetaData.type] = this.textFieldTypeOperands;
            } else if (columnMetaData.type === 'DATE') {
                this.operandsMap[columnMetaData.type] = this.dateFieldTypeOperands;
            } else if (columnMetaData.type === 'DROPDOWN') {
                this.operandsMap[columnMetaData.type] = this.dropDownTypeOperands;
            } else if (columnMetaData.type === 'CHECKBOX') {
                this.operandsMap[columnMetaData.type] = this.checkboxTypeOperands;
            } */
            // hidden fields should not be displayed for search if isHiddenFieldsEnabled is false
            if (columnMetaData.isMandatory === false && columnMetaData.displayType !== 'H' &&
                !(this.searchService.searchParams.hiddenPropertiesForFilter.indexOf(column.propertyName) > -1)) {
                this.criterias.push({
                    id: column.propertyName,
                    name: this.resourceService.get(column.elementId)
                });
            }
        });
    }
    // method used to render the dropdown values based on storer key
    public getOptionsForProperty(property: string) {
        let values = [];
        this.filterComponent.filteredDropdownVal.forEach(dropdownValue => {
            if (dropdownValue.key === property) {
                values = dropdownValue.value;
            }
        });
        return values;
    }

    public populateDropdownValues() {
        this.filteredDropdownVal = [];
        this.storerKey = [];
        this.searchService.getSearchCriteria().conditions.forEach(condition => {
            if (condition.isMandatory === true) {
                condition.clauses.forEach(clause => {
                    if (clause.column === 'storerKey') {
                        this.storerKey.push(clause.value?clause.value.toLowerCase() : null);
                        this.isStorerMandatory = true;
                    }
                });
            }
        });
        if (this.storerKey.includes('*')) {            
            if (this.userService.getUserRestrictions('Storer').length !== 0) {
                this.storerKey = [];
                this.storerKey = this.userService.getUserRestrictions('Storer');
            } else {
                this.isStorerMandatory = false;
            }
        }
        for (const data in this.filterComponent.metaDataMap) {
            if (this.filterComponent.metaDataMap[data].type === 'DROPDOWN' ||
                this.filterComponent.metaDataMap[data].type === 'EDITABLEDROPDOWN') {
                const valueArray = [];
                this.filterComponent.metaDataMap[data].values.forEach(value => {
                    if (this.storerKey.length > 1) {
                        valueArray.push(value);
                    } else {
                        if (this.storerKey.includes(value.storerKey?value.storerKey.toLowerCase():null)) {
                            valueArray.push(value);
                        }
                    }
                });
                if(valueArray.length > 0) {
                    valueArray.unshift({ key: '', value: '- Select -', storerKey: null, userDefineValues: null });
                }
                if (valueArray.length === 0 ) {
                    this.filterComponent.metaDataMap[data].values.forEach(value => {
                        if (value.storerKey === '' || value.storerKey === null || !this.isStorerMandatory) {
                            valueArray.push(value);
                        }
                    });
                }
                // LFWM - 3472 dropdown options were missing for those screens which doesn't have storerkey
                if (this.storerKey.length === 0 && valueArray.length === 1) {
                    this.filterComponent.metaDataMap[data].values.forEach(value => {
                        valueArray.push(value);
                    });
                    valueArray.shift();
                }
                this.filteredDropdownVal.push({
                    key: data,
                    value: valueArray
                });
            }
        }
    }
    // method used to set default values to the dropdown
    public setDefaultDropdownValues(clause: any) {
        this.populateDropdownValues();
        let storerKeyMatch = false;
        let storerKeyArr = [];
        this.searchService.getSearchCriteria().conditions.forEach(condition => {
            if (condition.isMandatory === false) {
                condition.clauses.forEach(clauses => {
                    for (const data in this.filterComponent.metaDataMap) {
                        if (this.filterComponent.metaDataMap[data].type === 'DROPDOWN' ||
                            this.filterComponent.metaDataMap[data].type === 'EDITABLEDROPDOWN') {
                            if (this.filterComponent.metaDataMap[data].propertyName === clauses.column) {
                                for (const value of this.filterComponent.metaDataMap[data].values) {
                                    if (clause.value === '*') {
                                        storerKeyArr = this.userService.getUserRestrictions('Storer');

                                        if (storerKeyArr.includes(value.storerKey)) {
                                            clauses.value = value.key;
                                            storerKeyMatch = true;
                                            break;
                                        }
                                        /* only if value is present for value.storeKEy then it needs
                                        to be compared earlier null equals null and entering the loop*/
                                    } else if (value.storerKey && (value.storerKey === clause.value)) {
                                        clauses.value = value.key;
                                        storerKeyMatch = true;
                                        break;
                                    }
                                }
                                // Jira -1254: Commenting the below code for not getting set the dropdown values to default value when we clear the conditions
                                // if (storerKeyMatch === false) {
                                //     for (const value of this.filterComponent.metaDataMap[data].values) {
                                //         if (value.storerKey === '' || value.storerKey === null) {
                                //             clauses.value = value.key;
                                //             break;
                                //         }
                                //     }
                                // }
                            }
                        }
                    }
                });
            }
        });
    }
    // method used for creating conditions including bot mandatory and non mandatory
    public createDefaultSearchCriteria() {
        // Setting the default Mandatory condition on load
        const mandatoryCondition = new Condition();
        mandatoryCondition.id = 1;
        mandatoryCondition.isMandatory = true;
        mandatoryCondition.operator = 'AND';
        mandatoryCondition.displayMode = 'VIEW';
        mandatoryCondition.clauses = new Array<Clause>();
        // Setting the default Non Mandatory condition on load
        const nonMandatoryCondition = new Condition();
        nonMandatoryCondition.id = 2;
        nonMandatoryCondition.isMandatory = false;
        nonMandatoryCondition.displayMode = 'VIEW';
        nonMandatoryCondition.clauses = new Array<Clause>();
        nonMandatoryCondition.operator = 'AND';
        this.metaData.columnList.forEach((column: any, index: any) => {
            // need to display only high priority columns in the form
            if (column.priority === 'HIGH') {
                const clause = new Clause();
                clause.id = column.id;
                if (index === 0) {
                    clause.logicalOperation = '';
                } else {
                    clause.logicalOperation = 'AND';
                }
                clause.column = column.propertyName;
                clause.operation = column.defaultOp;
                clause.typeOfField = column.type;
                if (clause.column === 'storerKey') {
                    clause.value = this.getDefaultStorerValue(column.defaultVal);
                } else if (clause.column === 'facility') {
                    clause.value = this.getDefaultFacilityValue(column.defaultVal);
                } else if (column.type === 'DATE' || column.type === 'DATETIME') {
                    // defaultValue of date field is formated to show the value in country specific date format
                    clause.formattedDateValue = this.dateConfigService.getFormattedDisplayDate(column.defaultVal);
                    clause.value = column.defaultVal;
                } else {
                    clause.value = column.defaultVal;
                }
                if (column.isMandatory) {
                    mandatoryCondition.clauses.push(clause);
                } else {
                    nonMandatoryCondition.clauses.push(clause);
                    nonMandatoryCondition.clauses[0].logicalOperation = '';
                }
            }
        });
        const searchCriteria = new SearchCriteria();
        if (mandatoryCondition.clauses.length > 0) {
            searchCriteria.conditions.push(mandatoryCondition);
        }
        if (nonMandatoryCondition.clauses.length > 0) {
            searchCriteria.conditions.push(nonMandatoryCondition);
        }
        return searchCriteria;
    }

    // method to get default storer value from user info restricitons
    private getDefaultStorerValue(defaultValue: any) {
        if (defaultValue === undefined) {
            defaultValue = '';
        }
        const userStorers = this.userService.getUserRestrictions('Storer');
        if (userStorers.length > 0) {
            if (userStorers.indexOf(defaultValue) !== -1) {
                return defaultValue;
            } else {
                if (userStorers.length > 1) {
                    return '*';
                } else {
                    return userStorers[0];
                }
            }
        } else {
            return defaultValue;
        }
    }

    // method to get default facility value from user info restricitons
    private getDefaultFacilityValue(defaultValue: any) {
        if (defaultValue === undefined) {
            defaultValue = '';
        }
        const userFacility = this.userService.getUserRestrictions('Facility');
        if (userFacility.length > 0) {
            if (userFacility.indexOf(defaultValue) !== -1) {
                return defaultValue;
            } else {
                if (userFacility.length > 1) {
                    return '*';
                } else {
                    return userFacility[0];
                }
            }
        } else {
            return defaultValue;
        }
    }

    public getColumnMetaData(column: any) {
        // populate metadata into the map
        const columnMetaData = new ColumnMetaData();
        columnMetaData.id = column.id;
        columnMetaData.propertyName = column.propertyName;
        columnMetaData.elementId = column.elementId;
        columnMetaData.displayValue = this.resourceService.get(column.elementId);
        columnMetaData.type = column.type;
        columnMetaData.displayType = column.displayType;
        columnMetaData.defaultVal = column.defaultVal;
        columnMetaData.isMandatory = column.isMandatory;
        columnMetaData.defaultOp = column.defaultOp;
        columnMetaData.maxLength = column.maxLength;
        columnMetaData.index = column.index;
        columnMetaData.priority = column.priority;
        columnMetaData.toolTip = column.toolTip;
        columnMetaData.dataType = column.dataType;
        if (column.type === 'DROPDOWN' || column.type === 'EDITABLEDROPDOWN') {
            columnMetaData.values = [];
            /* setting the default value in the dropdown if the dropdown values
             list is empty for dropdown type fields */
            /*  if (column.values.length == 0) {
                columnMetaData.values.push({
                    key: 0,
                    value: column.defaultVal
                 }); */
            /* Wildcard Search Value should only be added if it is not
                present as a key in metadata.value */
            const wildcardClausePresent: boolean
                = column.values
                    .filter((keyValueObject: any) => {
                        return keyValueObject.key === 'ALL';
                    }).length > 0;
            column.values.forEach((dropDownValue: any) => {
                // setting dropdown values for mandatory fields
                if (columnMetaData.isMandatory) {
                    if (columnMetaData.dataType !== 'Object') {
                        if (!wildcardClausePresent) {
                            columnMetaData.values[0] = {
                                key: '*',
                                value: 'ALL',
                                storerKey: null
                            };
                        }
                        columnMetaData.values.push({
                            key: dropDownValue.key,
                            value: /*dropDownValue.key + ' - ' +*/ dropDownValue.value,
                            storerKey: dropDownValue.storerkey
                        });
                        // this condition will exceute only for transmitlog screen on given conditions
                        // if one needs dropdown without ALL or * option by default, can change metadata accordingly and reuse
                    } else {
                        columnMetaData.values.push({
                            key: dropDownValue.key,
                            value: dropDownValue.value,
                            storerKey: dropDownValue.storerkey
                        });
                    }
                } else {
                    columnMetaData.values.push({
                        key: dropDownValue.key,
                        value: /*dropDownValue.key + ' - ' +*/ dropDownValue.value,
                        storerKey: dropDownValue.storerkey
                    });
                }
            });
            /*
            } else {
                columnMetaData.values = column.values;
                column.values.forEach((dropDownValue: any) => {
                    this.dropDownValuesMap[dropDownValue.key] = dropDownValue;
                });
            }
            */
        }
        return columnMetaData;
    }

    // method for populating dynamic value fields based on first criteria dropdown
    public dynamicValuesFunction(type: any, i: any) {
        if (type === 'TEXTFIELD') {
            this.textBox[i] = true;
            this.date[i] = false;
            this.dropDown[i] = false;
            this.checkBox[i] = false;
            this.dateTime[i] = false;
        }
        if (type === 'DATE' || type === 'DATETIME') {
            this.date[i] = true;
            this.textBox[i] = false;
            this.dropDown[i] = false;
            this.checkBox[i] = false;
            this.dateTime[i] = false;
        }
        if (type === 'DROPDOWN' || type === 'EDITABLEDROPDOWN') {
            this.dropDown[i] = true;
            this.textBox[i] = false;
            this.date[i] = false;
            this.checkBox[i] = false;
            this.dateTime[i] = false;
        }
        if (type === 'CHECKBOX' || type === 'CHECKBOX_CHR') {
            // Adding CHECKBOX_CHR type denoting the saved value will be 'Y' or 'N'
            // CHECKBOX type denoting the saved value will be '1' or '0'
            this.checkBox[i] = true;
            this.dropDown[i] = false;
            this.textBox[i] = false;
            this.date[i] = false;
            this.dateTime[i] = false;
        }
        if (type === 'DATETIME') {
            this.dateTime[i] = true;
            this.date[i] = false;
            this.textBox[i] = false;
            this.dropDown[i] = false;
            this.checkBox[i] = false;
        }
    }

    // method for deleting a particular condition
    public deleteCondition(conditionId: any, index: any) {
        this.searchService.setNonMandatoryConditionsCount(0);
        this.searchService.setDeletedSearchCriteria(this.searchService.getSearchCriteria().conditions[index]);
        this.searchService.getSearchCriteria().conditions.forEach((cond: any) => {
            if (cond.id === conditionId) {
                this.searchService.getSearchCriteria().conditions.splice(index, 1);
            }
        });
        // checking the count of non mandatory conditions in the formed search criteria
        this.checkNonMandatoryCondition();
    }

    private checkNonMandatoryCondition(){
        this.searchService.getSearchCriteria().conditions.forEach((condition: any) => {
            if (condition.isMandatory === false) {
                this.searchService.setNonMandatoryConditionsCount(this.searchService.getNonMandatoryConditionsCount() + 1);
            }
        });        
    }


    public rebuildSearchCriteria() {
        const searchCriteria = this.searchService.getSearchCriteria();
        // validation part
        let isValidSearchCriteria = true;
        let errMsg: string;
        searchCriteria.conditions
            .forEach((condition: any) => {
                condition.clauses.forEach((clause: any) => {
                    if ((clause.isValid !== undefined) && !clause.isValid) {
                        isValidSearchCriteria = false;
                        errMsg = clause.validationErrMsg;
                        return false;
                    }
                });
            });
        if (!isValidSearchCriteria) {
            throw new Error(this.resourceService.get(errMsg));
        }
        // ends here
        if (searchCriteria.conditions.length > 0) {
            searchCriteria.conditions.forEach((condition: any) => {
                condition.clauses.forEach((clause: any) => {
                    if (condition.isMandatory && clause.value === '') {
                        clause.value = '*';
                    }
                    //[LFWM-2732][PROD | Philippines | SCE | TradeReturn| Carrier]
                    //The following lookup need to be handle the scenario
                    //changing carrier lookup,seller lookup , ship to lookup in so and billto in so, condition as editable
                    //     * to display type as string instead of numeric value in lookup's for user understanding
                    //     [ex: 1 - storer] when rebuilding search criteria after clicking search button */
                    // 3,5,2 are the  the value which need to be default the drop down 
                    let lookupColumnList: { [key: string]: string } = {
                        'carrierType': '3',
                        'sellerType': '5',
                        'storerType': '2'
                    }
                    if (Object.keys(lookupColumnList).includes(clause.column)) {
                        if (clause.value === '*') {
                            // this scenario should be handled in backend. it's a temproary fix
                            clause.value = lookupColumnList[clause.column];
                        }
                        this.getType();
                    }
                });
                const filteredClauses = condition.clauses.filter((clause: any) => {
                    if (clause.value === undefined || clause.value === '' || clause.value === null ||
                        (clause.operation === 'between' && (clause.value1 === undefined || clause.value1 === ''))) {
                        return false;
                    }
                    return true;
                });
                if (filteredClauses.length === 0) {
                    const errorMessage = 'lbl_inclClmnCondn';
                    throw new Error(this.resourceService.get(errorMessage));
                }
                condition.clauses = filteredClauses;
                if (condition.clauses.length > 0) {
                    condition.clauses[0].logicalOperation = null;
                }
            });
            const filteredConditions = searchCriteria.conditions.filter((condition: any) => {
                if (condition.clauses === null || condition.clauses.length === 0) {
                    return false;
                } else {
                    return true;
                }
            });
            if (searchCriteria.loadDefaultCriteria && filteredConditions.length === 0) {
                const errorMessage = this.resourceService.get('msg_cndtn_req');
                throw new Error(this.resourceService.get(errorMessage));
            }
            searchCriteria.conditions = filteredConditions;
        }
        this.searchService.setSearchCriteria(searchCriteria);
    }

    // method to add new condition
    public addNewCondition() {
        this.searchService.setNonMandatoryConditionsCount(0);
        try {
            this.rebuildSearchCriteria();
            this.alertService.clearAll();
        } catch (error) {
            this.alertService.clearAll();
            this.alertService.error(this.resourceService.get(error.message));
            return false;
        }
        this.searchService.getSearchCriteria().conditions.forEach((condition: any) => {
            if (condition.displayMode === 'EDIT') {
                condition.displayMode = 'VIEW';
            }
            condition.clauses.forEach(clause => {
                const type = this.filterComponent.metaDataMap[clause.column].type;
                if (clause.operation === 'between') {
                    // Code changes for between operator
                    if ((type === 'DATE' || type === 'DATETIME') && clause.value && clause.value1) {
                        clause.formattedDateValue = this.filterComponent.formatDate(clause.value, type);
                        clause.formattedDateValue1 = this.filterComponent.formatDate(clause.value1, type);
                    }
                } else {
                    if ((type === 'DATE' || type === 'DATETIME') && clause.value) {
                        clause.formattedDateValue = this.filterComponent.formatDate(clause.value, type);
                    }
                }
            });
        });
        const newCondition = new Condition();
        newCondition.id = this.searchService.getSearchCriteria().conditions.length + 1;
        newCondition.isMandatory = false;
        newCondition.displayMode = 'EDIT';
        newCondition.operator = 'AND';
        newCondition.clauses = [];
        const newClause = new Clause();
        newClause.column = this.criterias[0].id;
        newClause.id = this.metaDataMap[newClause.column].id;
        newClause.operation = this.metaDataMap[newClause.column].defaultOp;
        //LFWM-2639 
        newClause.typeOfField = this.metaDataMap[newClause.column].type;
        newClause.logicalOperation = '';
        newClause.value = '';
        newCondition.clauses.push(newClause);
        newCondition.clauses.forEach((_clause: any, index: any) => {
            this.dynamicValuesFunction(this.metaDataMap[newClause.column].type, index);
        });
        this.searchService.getSearchCriteria().conditions.push(newCondition);
        // checking the count of non mandatory conditions in the formed search criteria
        this.checkNonMandatoryCondition();
    }

    // method listening  populate the logical operation between various conditions in a particular filter
    public addConditionOperator(conditionId: any, logOp: any, idx: any) {
        this.searchService.getSearchCriteria().conditions
            .forEach((condition: any, index: any) => {
                if (condition.id === conditionId) {
                    if (index === idx) {
                        condition.operator = logOp;
                    }
                }
            });
    }

    // method for emitting the search criteria object to the component
    public handleSearchClick() {
        if (this.searchService.searchParams.tableId === 'assignpickloctd') {
            let filteredClauses: Array<any> = [];
            this.searchService.getSearchCriteria().conditions
                .map((condition: any) => {
                    const facilityClauses: Array<any> = condition.clauses
                        .filter((clause: any) => {
                            return (clause.column === 'assignFacility');
                        });
                    filteredClauses = filteredClauses.concat(facilityClauses);
                });
            if (filteredClauses.length > 0) {
                filteredClauses.forEach((clause: any) => {
                    if (clause.value === '*') {
                        this.alertService.clearAll().error('Wild card search is disabled for facility');
                        return;
                    }
                });
            } else {
                this.alertService.clearAll().error('Facility is mandatory in location search');
                return;
            }
        }
        if (this.searchService.searchParams.tableId === 'assignpickskutd') {
            let filteredClauses: Array<any> = [];
            this.searchService.getSearchCriteria().conditions
                .map((condition: any) => {
                    const storerClauses: Array<any> = condition.clauses
                        .filter((clause: any) => {
                            return (clause.column === 'assignStorer');
                        });
                    filteredClauses = filteredClauses.concat(storerClauses);
                });
            if (filteredClauses.length > 0) {
                filteredClauses.forEach((clause: any) => {
                    if (clause.value === '*') {
                        this.alertService.clearAll().error('Wild card search is disabled for storer');
                        return;
                    }
                });
            } else {
                this.alertService.clearAll().error('Storer is mandatory in commodity search');
                return;
            }
        }
        // if it is in 'Edit' mode then only check the validation part
        // else continue directly with search action
        if (this.searchService.getDisplayMode() === 'E') {
            if (this.navService.preventNavigation && this.navService.preventNavigation === true) {                
                const dialogMsg = [`<b>  ${this.resourceService.get('mn_data_lost_msg')}  </b>`, this.resourceService.get('mn_nav_confirm_msg')];
                this.confirmDialogService.yesnocancelDialog(this.resourceService.get(dialogMsg)).subscribe((isConfirmed: any) => {
                    if (isConfirmed === true) {
                        this.searchAction();
                        this.dataService.setDisplayMode('V');
                        this.navService.preventNavigation = false;
                    }
                });
            } else {
                this.searchAction();
                this.dataService.setDisplayMode('V');
                this.navService.preventNavigation = false;
            }

        } else {
            this.searchAction();
        }
    }

    private searchAction() {
        try {
            this.rebuildSearchCriteria();
            this.alertService.clearAll();
        } catch (error) {
            this.alertService.clearAll();
            this.alertService.error(error.message);
            return false;
        }
        let errorCaught = false;
        this.searchService.getSearchCriteria().conditions
            .forEach((condition: any) => {
                // converting the format of date type values
                condition.clauses.forEach((clause: any) => {
                    const type = this.filterComponent.metaDataMap[clause.column].type;
                    if (type === 'DATE' || type === 'DATETIME') {
                        if (clause.operation === 'between') {
                            clause.formattedDateValue = this.filterComponent.formatDate(clause.value, type);
                            clause.formattedDateValue1 = this.filterComponent.formatDate(clause.value1, type);
                        } else {
                            clause.formattedDateValue = this.filterComponent.formatDate(clause.value, type);
                        }
                    }
                });
                if (condition.displayMode === 'EDIT') {
                    condition.displayMode = 'VIEW';
                }
            });

        /*This is the validations for PalletImageInquiry   */
        if (this.searchService.searchParams.tableId === 'palletimagesearchtd') {
            const conditions: any = this.searchService.getSearchCriteria().conditions;
            const noOfConditions: any = conditions.length;
            let noOfConditionInClause: any;
            if (conditions[0] && conditions[0].clauses) {
                noOfConditionInClause = conditions[0].clauses.length;
            }
            let fromDate: any;
            let todate: any;
            if (noOfConditions < 1 || noOfConditionInClause < 1) {
                this.alertService.error('Require atleast 1 parameter');
                errorCaught = true;
                return;
            }
            conditions.forEach((condition: any) => {
                // converting the format of date type values
                condition.clauses.forEach((clause: any) => {
                    const type = this.filterComponent.metaDataMap[clause.column].type;
                    if ((clause.column === 'fromDate' || clause.column === 'toDate')) {
                        if (noOfConditions === 1 && noOfConditionInClause === 1) {
                            this.alertService.error('require both from and to dates');
                            errorCaught = true;
                            return;
                        } else if (clause.column === 'fromDate') {
                            fromDate = clause.value;
                        } else if (clause.column === 'toDate') {
                            todate = clause.value;
                        }
                        if (fromDate && todate) {
                            if ((Date.parse(fromDate) >= Date.parse(todate))) {
                                this.alertService.error('End date should be greater than Start date');
                                errorCaught = true;
                                return;
                            }
                        }
                    }
                    if (type === 'DATE' || type === 'DATETIME') {
                        if (clause.operation === 'between') {
                            clause.formattedDateValue = this.filterComponent.formatDate(clause.value, type);
                            clause.formattedDateValue1 = this.filterComponent.formatDate(clause.value1, type);
                        } else {
                            clause.formattedDateValue = this.filterComponent.formatDate(clause.value, type);
                        }
                    }
                });
                if (condition.displayMode === 'EDIT') {
                    condition.displayMode = 'VIEW';
                }
            });

        }
        this.searchService.clearSearchStatus();
        // clearing filter condition
        this.searchService.setFilterCondition(null);
        this.searchService.getPagedData().pageDefinition.pageNumber = 1;
        if (errorCaught) {
            return;
        } else {
            this.searchService.performSearch();
        }
    }

    // type is used to diffrenciate whether the type of date value is date or datetime
    public formatDate(date: any, type: string) {
        if (type === 'DATE') {
            return this.dateConfigService.getFormattedDisplayDate(date);
        } else if (type === 'DATETIME') {
            // default input date format is YYYY-MM-DD, so length of the date is 10
            if (date.length === 10) {
                return this.dateConfigService.getFormattedDisplayDate(date);
            } else {
                return this.dateConfigService.getFormattedDisplayDateTime(date);
            }
        }
    }

    public ngOnDestroy() {
        this.searchService.setNonMandatoryConditionsCount(0);
        if (this.searchService.getSearchCriteria()) {
            this.searchService.getSearchCriteria().conditions
                .forEach((condition: any) => {
                    // converting the format of date type values
                    condition.clauses.forEach((clause: any) => {
                        const type = this.filterComponent.metaDataMap[clause.column].type;
                        if (type === 'DATE' || type === 'DATETIME') {
                            if (clause.operation === 'between') {
                                clause.formattedDateValue = this.filterComponent.formatDate(clause.value, type);
                                clause.formattedDateValue1 = this.filterComponent.formatDate(clause.value1, type);
                            } else {
                                clause.formattedDateValue = this.filterComponent.formatDate(clause.value, type);
                            }
                        }
                    });
                    if (condition.displayMode === 'EDIT') {
                        condition.displayMode = 'VIEW';
                    }
                });
        }
    }

    // method used to display type as string instead of numeric value in lookup's for user understanding
    public getType() {
        this.filterComponent.metaData.columnList.forEach(column => {
            this.searchService.getSearchCriteria().conditions.forEach((condition: any) => {
                condition.clauses.forEach((clause: any) => {
                    column.values.forEach((typeMap: any) => {
                        /**
                         * The below if condition checks for column 'Type' and also
                         * checks for storer, seller, build to, ship to column name  where their value in service side represented as numeric (1,2,3)
                         * in order to convert these numeric values to user understandable string below check is performed.
                         * in certain specific case like Assign lane popup, there is a column named 'Type' and
                         * there are some empty values which satisfy the below condition and wrongly enter into this flow
                         * in order to avoid this exception extra one more check 'condition.isMandatory' is added
                         */
                        if (this.filterComponent.metaDataMap[clause['column']].displayValue === 'Type'
                            && clause['value'] === typeMap.key && condition.isMandatory) {
                            this.showLookupType = true;
                            this.filterComponent.type = typeMap.value;
                        }
                    });
                });
            });
        });
    }

    // method used to fetch the column attribute from service
    public initializeTableColumnAttribute() {
        this.searchService.fetchTableColumnAttribute()
            .subscribe((tableColumnAttribute: any) => {
                this.tableColumnAttribute = tableColumnAttribute;
                this.searchService.setTableColumnAttribute(tableColumnAttribute);
            });
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/filter/search-filter.component.ts